"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgUpdate = function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 30 1020 1030",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M511 36.53q-75 0-146.5 22.5T231 124.53q-61 42-107 99t-74 126q-4 9-3 18.5t6 17.5q5 9 13.5 13.5t18.5 4.5q11 0 20-6.5t14-16.5q25-61 65-110.5t91.5-84q51.5-34.5 111.5-53.5t124-19q70 0 136 23t122 67l94 74-125 20 215 99 2-243-49 74-44-44q-35-35-76-62.5t-85.5-46.5q-44.5-19-92.5-28.5t-97-9.5zm-395 831 44 44q35 36 76 63.5t85.5 46q44.5 18.5 92 28t97.5 9.5q75 0 146.5-22t133.5-65q61-42 107-99.5t74-125.5q4-9 3-19t-6-18q-5-8-13.5-12.5t-18.5-4.5q-11 0-20 6t-14 17q-25 61-65 110t-91.5 84q-51.5 35-111.5 54t-124 19q-70 0-136-23t-122-68l-94-74 125-20-215-98-2 242 49-74z"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgUpdate);
var _default = Memo;
exports["default"] = _default;